











import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { FollowingStatistic } from "@scrile/api-provider/dist/api/FollowingsProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import WithContentFeed from "@/mixins/WithContentFeed";
import providers from "@/lib/api";
import { CheckRole } from "@/lib/decorators";
import config from "@/config";
import ProfileStatisticView from "../ProfileStatisticView";

@Component({ name: "ProfileStatistic", components: { ProfileStatisticView } })
export default class ProfileStatistic extends mixins(WithContentFeed, WithAuthUser) {
  @Prop({ type: String, required: true })
  public readonly userId!: string;

  @Prop({ type: Boolean, default: false })
  public readonly isAuthor!: boolean;

  @Prop({ type: Object as () => UserPublicData, required: true })
  public readonly user!: UserPublicData;

  public followingStatistic: FollowingStatistic | null = null;

  public postsStatistic: number = 0;

  public likesStatistic: number = 0;

  @CheckRole("admin")
  public isAdmin!: boolean;

  @Watch("userId", { immediate: true })
  public async watchUserId(userId: string) {
    this.getData(userId);
  }

  public get showFollowers(): boolean {
    return this.isAuthor || config.featurePublicFollowers || this.isAdmin;
  }

  public get showFollowing(): boolean {
    return this.isAuthor || config.featurePublicFollowing || this.isAdmin;
  }

  public get showLikes(): boolean {
    return config.featureProfileLikeStats && this.user.role === "creator";
  }

  public getData(userId: string) {
    if (this.showFollowers || this.showFollowing) {
      providers.FollowingsProvider.getStatistic({ ids: [userId] }).then(r => (this.followingStatistic = r[0] ?? null));
    }
    if (this.showLikes) {
      providers.LikeProvider.getStatsByOwners({
        data: { ownerIds: [userId], subjectType: PurchaseSubjectTypeEnum.CONTENT_SET },
      }).then(r => (this.likesStatistic = r[userId]));
    }
    this.contentFeedStatsGetCount(userId).then(r => (this.postsStatistic = r));
  }
}
